import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";

const clean = (t) => t.replace(/^[^\p{L}\p{N}_]+|[^\p{L}\p{N}_]+$/gu, "");
const isRed = (tok, kw) => !!kw && clean(tok).toLowerCase() === kw.toLowerCase();

const QuoteRow = ({ q, onPick }) => {
  let done = false;
  return (
    <div className="card-panel p-4" data-testid={`redword-row-${q.id}`}>
      <p className="text-base leading-relaxed">
        {q.text.split(/\s+/).map((tok, i) => {
          const red = !done && isRed(tok, q.keyword);
          if (red) done = true;
          return (
            <button key={i} onClick={() => onPick(q, clean(tok))} className={`mr-1.5 rounded px-0.5 ${red ? "text-[#FD0F10] font-black underline" : "text-gray-100 hover:bg-[#2A2E39]"}`} data-testid={`redword-${q.id}-${i}`}>
              {tok}
            </button>
          );
        })}
      </p>
      <div className="mt-2 flex items-center justify-between text-xs">
        <span className="text-gray-500">{q.author} · {q.topic}</span>
        {q.keyword ? (
          <button onClick={() => onPick(q, "")} className="text-gray-400 hover:text-white font-mono-ui uppercase tracking-wider" data-testid={`redword-clear-${q.id}`}>Remove red word</button>
        ) : <span className="text-[#FD0F10] font-bold" data-testid={`redword-none-${q.id}`}>No red word yet</span>}
      </div>
    </div>
  );
};

export default function AdminRedWords() {
  const [quotes, setQuotes] = useState([]);
  const [find, setFind] = useState("");
  const [missingOnly, setMissingOnly] = useState(false);
  useEffect(() => { api.get("/mindset/quotes").then((r) => setQuotes(r.data.quotes)).catch(() => toast.error("Couldn't load quotes.")); }, []);
  const onPick = async (q, keyword) => {
    try {
      await api.put(`/admin/mindset/quotes/${q.id}`, { text: q.text, author: q.author, topic: q.topic, keyword });
      setQuotes((all) => all.map((x) => (x.id === q.id ? { ...x, keyword } : x)));
      toast.success(keyword ? `Red word: ${keyword}` : "Red word removed.");
    } catch (e) { toast.error(e?.response?.data?.detail || "Couldn't save."); }
  };
  const f = find.trim().toLowerCase();
  const shown = quotes.filter((q) => (!missingOnly || !q.keyword) && (!f || `${q.text} ${q.author}`.toLowerCase().includes(f)));
  return (
    <div className="max-w-3xl mx-auto px-5 py-8 pb-28" data-testid="admin-redwords-page">
      <Link to="/admin" className="text-xs font-mono-ui uppercase tracking-wider text-gray-400 hover:text-white" data-testid="redwords-back">← Admin</Link>
      <h1 className="mt-3 font-display text-3xl font-black text-white">Red word review</h1>
      <p className="mt-1 text-sm text-gray-400">All {quotes.length} quotes. Tap any word to make it the red word. It saves straight away.</p>
      <div className="mt-4 flex flex-wrap gap-2 items-center">
        <input value={find} onChange={(e) => setFind(e.target.value)} placeholder="Search quote or author" className="flex-1 min-w-[180px] bg-[#0B0C0E] border border-[#2A2E39] rounded px-3 py-2 text-sm text-gray-100" data-testid="redwords-search" />
        <label className="text-sm text-gray-300 flex items-center gap-2"><input type="checkbox" checked={missingOnly} onChange={(e) => setMissingOnly(e.target.checked)} data-testid="redwords-missing-only" /> Only quotes with no red word</label>
      </div>
      <p className="mt-3 text-xs text-gray-500" data-testid="redwords-count">Showing {shown.length}</p>
      <div className="mt-3 space-y-3">{shown.map((q) => <QuoteRow key={q.id} q={q} onPick={onPick} />)}</div>
    </div>
  );
}
